import React, { useState, useCallback, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import useStyles from "./style";
import { Button, Grid, Typography , Menu , MenuItem ,TextField } from "@mui/material";
import {EditOutlined ,DeleteOutline , History} from "@mui/icons-material";
import { DataGrid  } from "@mui/x-data-grid";
import "jspdf-autotable";

import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { useFormik } from "formik";
import * as yup from "yup";
import _ from "lodash";
import moment from 'moment-timezone';
import { CUSTOM_CONSTANTS } from "Constants";

//Services
import UserwalletApi from "Services/Wallet"

const Userwalletlogs = () => {
  const { id:walletid , user_id:userId} = useParams();
  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [row, setRow] = useState([]);

  //Pagination

  const [page, setPage] = useState(1); // Initial page number
  const [pageSize, setPageSize] = useState(5); // Initial page size
  const [totalPages, setTotalPages] = useState(1);
  const [totalamount, setTotalamount] = useState(0);
  const MONEY_OPTIONS = [20, 40, 60];
  const [selectedAmount, setSelectedAmount] = useState(null); // for styling selection 
  const timezone = useSelector((state) => state.timezone.timezone);
  
  // Get userWallet list api
  const getuserWalletlogs = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
      //  console.log('res?.data?.data-->',res?.data?.data);
        setTotalPages(res?.data?.data?.totalRecords || 1);
        setRow(res?.data?.data?.data);
        setTotalamount(res?.data?.data?.data?.[0].userwallet?.walletBalance || 0);
      } else {
        setRow([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("error fetch service area", err);
    };
    UserwalletApi
      .getusersWalletLogs({ page, limit: pageSize , walletID:walletid})
      .then(onSuccess, onFailure);
  }, [page, pageSize]);

  useEffect(() => {
    getuserWalletlogs();
  }, [getuserWalletlogs]);

  const calculateSno = (pageIndex, pageSize, index) => {
    return (pageIndex - 1) * pageSize + index + 1;
  };

  const handlePageChange = (newPage) => {
    let theNewPage = parseInt(newPage) + 1;
    if (theNewPage >= 1) {
      setPage(theNewPage);
    }
  };

  function formatDate(inputDate) {
    if (!inputDate) return "--";
  
    // Handle MongoDB date object: { $date: "..." }
    const dateValue = inputDate?.$date || inputDate;
  
    if (!dateValue) return "--";
  
    // Fallback timezone if undefined
    const tz = timezone || "UTC";
  
    // Validate date before formatting
    if (!moment(dateValue).isValid()) return "--";
  
    return moment(dateValue).tz(tz).format("YYYY-MM-DD hh:mm A");
  }


  const dataRows = _.map(row || [], (data, index) => ({
    sno: calculateSno(page, pageSize, index),
    username: data?.userdetails?.user_name,
    email: data?.userdetails?.email,
    mobile: data?.userdetails?.countryCode+" "+data?.userdetails?.mobileNumber,
    mode: data?.paymentUpdatedType,
    amount: data?.creditedAmount,
    status: data?.paymentStatus,
    createdAt:formatDate(data?.createdAt),
    row: data,
  }));
  
  const columns = [
    {
      field: "sno",
      headerName: "S.No",
      width: 90,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <>
            <div className={classes.lightText}>
              <Typography variant="body2">{params?.row?.sno}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "username",
      headerName: "Name",
      width: 150,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
          <Typography variant="body2"  
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            fontWeight:"bold",
            color: "#9c27b0", // Optional: Color to indicate it's clickable
          }}>{params?.row?.username}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "email",
      headerName: "Email",
      width: 150,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.email}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "mobile",
      headerName: "Mobile",
      width: 150,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.mobile}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "mode",
      headerName: "Mode",
      width: 150,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{"Added by ("+ params?.row?.mode +")"}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "amount",
      headerName: "Amount",
      width: 150,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.amount+" "+CUSTOM_CONSTANTS.BASE_CURRENCY}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "status",
      headerName: "Status",
      width: 150,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.status}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "createdAt",
      headerName: "Date",
      width: 200,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.createdAt}</Typography>
            </div>
          </>
        );
      },
    }
  ];

  const handlePresetAmountClick = (amount) => {
    formik.setFieldValue("creditedAmount", amount);
    setSelectedAmount(amount);
  };  

const handleUpdatewallet = (formValues) => {
  dispatch(showLoader("Loading please wait..."));

  let validatationPass = true;

  const data = {
    creditedAmount: formValues?.creditedAmount,
    walletId:walletid,
    userId:userId
  };

  //console.log('data--->',data);

  const onSuccess = (res) => {
    dispatch(hideLoader());
    if (res?.data?.status === true) {
      dispatch(
        showSnackbar({
          message: "Rewards Updated Successfully",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "success",
        })
      );

      //console.log("the response data ", res?.data);
      // setProfileDetails([]);
      formik.resetForm();
      getuserWalletlogs();
      // getProfileDetails();
    }
  };
  const onFailure = (err) => {
    dispatch(hideLoader());
    dispatch(
      showSnackbar({
        message: err?.response?.data?.message || "Error while Update Manager",
        autoHideDuration: 3000,
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        variant: "error",
      })
    );
    //console.log("update profile details api", err);
  };

  if (validatationPass) {
    UserwalletApi.addwalletmoney(data).then(onSuccess, onFailure);
  }
};

const formik = useFormik({
  initialValues: {
    creditedAmount:""
  },
  validationSchema: yup.object({
    creditedAmount: yup.number().required("Amount is required").nullable(),
  }),
  enableReinitialize: true,
  onSubmit: handleUpdatewallet,
});
  

  return (
    <>
{/* Total amount display*/}

<Grid container direction="column" alignItems="center" spacing={1} className={classes.totalamountblock}>
      {/* Heading */}
      <Grid item>
        <Typography variant="subtitle1" fontWeight="bold">
          Total Rewards
        </Typography>
      </Grid>

      {/* Image Block */}
      <Grid item>
        <img src="/assets/images/page_images/wallet.png" alt="Wallet Icon" width={80} height={80} />
      </Grid>

      {/* Amount Display */}
      <Grid item>
        <Typography variant="h6" fontWeight="bold" color="primary">
          {totalamount.toFixed(2)+" "+ CUSTOM_CONSTANTS.BASE_CURRENCY} 
        </Typography>
      </Grid>
    </Grid> 

{/*Add amount form */}    
<Grid container alignItems="center" spacing={2} className={classes.formwrapper}>
  <Grid item>
    <Typography variant="subtitle1">Add Rewards</Typography>
    <Typography variant="caption">It's quick, safe & secure : </Typography>
  </Grid>

  <Grid item>
    <TextField
      inputProps={{ form: { autoComplete: "off" } }}
      id="creditedAmount"
      label={CUSTOM_CONSTANTS.BASE_CURRENCY}
      value={formik?.values?.creditedAmount}
      onChange={(e) => {
        formik.handleChange(e);
        setSelectedAmount(null); // Clear highlight if user types manually
      }}
      error={formik?.errors?.creditedAmount && formik?.touched?.creditedAmount}
      helperText={formik?.touched?.creditedAmount && formik?.errors?.creditedAmount}
      fullWidth
      variant="outlined"
      size="small"
    />
  </Grid>

  {MONEY_OPTIONS.map((amount) => (
    <Grid item key={amount}>
      <Button
        variant={selectedAmount === amount ? "contained" : "outlined"}
        style={{
          backgroundColor: selectedAmount === amount ? "#800080" : "#fff",
          color: selectedAmount === amount ? "#fff" : "#000",
          borderColor: "#ccc",
          minWidth: 80,
        }}
        onClick={() => handlePresetAmountClick(amount)}
      >
        {amount}
      </Button>
    </Grid>
  ))}

  <Grid item>
    <Button variant="contained" onClick={formik?.handleSubmit}>
      Add Rewards
    </Button>
  </Grid>

</Grid>


{/*Wallet details */}
<Grid container className={classes.walletdetails}>
  <Grid item xs={12}>
  <div style={{ overflowX: "auto" }}>
  <div style={{ minWidth: "1100px" }}>
    <section className={classes.dataGridTable}>
      <DataGrid
        getRowId={(row) => row?.row?._id}
        rows={dataRows}
        columns={columns}
        pageSize={pageSize}
        onPageSizeChange={(newPageSize) => {
          setPageSize(newPageSize);
          setPage(1);
        }}
        onPageChange={(newPage) => handlePageChange(newPage)}
        rowsPerPageOptions={[5, 10, 25, 50]}
        pagination
        autoHeight={true}
        disableSelectionOnClick
        scrollbarSize={4}
        rowHeight={70}
        style={{ padding: "10px", borderRadius: "0px" }}
        paginationMode="server"
        rowCount={totalPages}
      />
    </section>
   </div> 
   </div>
  </Grid>
</Grid>


    </>
  );
};

export default Userwalletlogs;
